import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const upsert = async (store, meta = {}) => {
  store.setState((state) => {
    state.admin.config.upsert.busy = true;
  });

  try {
    let response = await Http.post(`api/config`, meta);

    store.setState((state) => {
      state.admin.config.upsert.busy = false;
      state.admin.config.upsert.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.config.upsert.error = error.data || error;
      state.admin.config.upsert.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.config.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.admin.config.upsert = { ...initialState };
};

const actions = {
  upsert,
  resetError,
  reset,
};

const ConfigUpsertStore = {
  state: () => initialState,
  actions,
};

export default ConfigUpsertStore;
